import React, {Fragment, memo} from 'react';
import {useIntl} from 'react-intl';
import {graphql} from 'gatsby';

import * as iter from '../utils/iter';

export const query = graphql`
	fragment IntlString on IntlString {
		de
		en
	}
`;

export default memo(
	/**
	 * @param {{
	 *   handleLines?: boolean,
	 *   de: string,
	 *   en?: string | null,
	 * }} props
	 */
	function IntlString({handleLines, ...intlStr}) {
		const intl = useIntl();
		const s = intlString(intl, intlStr);
		if (handleLines) {
			const lines = s.trim().split('\n');
			const combined = iter.join(
				(<br />),
				iter.into(lines).map((l) => l.trim()),
			);
			return React.createElement(
				Fragment,
				undefined,
				// works only with arrays in loose mode
				...combined.toArray(),
			);
		} else {
			return (
				<Fragment>{s}</Fragment>
			);
		}
	}
);

/**
 * @param {import("react-intl").IntlShape} intl
 * @param {{
 *   de: string,
 *   en?: string | null,
 * }} intlStr
 * @return {string}
 */
export function intlString(intl, intlStr) {
	if (intl.locale === 'en' && !!intlStr.en) {
		return intlStr.en;
	}
	return intlStr.de;
}
